import { MDBTypography } from "mdb-react-ui-kit";
import React from "react";

const BLOG_ENDPOINT = process.env.BLOG_ENDPOINT;
const MEDIA_ENDPOINT = process.env.MEDIA_ENDPOINT;

const BLOCK_TYPES = {
  paragraph: ParagraphBlock,
  heading: HeadingBlock,
  image: ImageBlock,
};

function ParagraphBlock(props) {
  let value = props.value;
  value = value.replace(/h(\d) /g, "h$1 class='paragraph-header-h$1' ");
  return <p dangerouslySetInnerHTML={{ __html: value }}></p>;
}

function HeadingBlock(props) {
  return (
    <MDBTypography tag="h4" className="h4-responsive">
      {props.value}
    </MDBTypography>
  );
}

function ImageBlock(props) {
  const [content, setContent] = React.useState(null);

  React.useEffect(() => {
    fetch(BLOG_ENDPOINT + "/images/" + props.value)
      .then((response) => response.json())
      .then((data) => {
        setContent(data.meta.download_url);
      });
  }, []);

  return <img src={MEDIA_ENDPOINT + content} />;
}

function EmbeddedBlock(props) {
  const Block = BLOCK_TYPES[props.block.type];
  if (Block === undefined) {
    return null;
  }
  return (
    <div key={props.key}>
      <Block value={props.block.value} />
    </div>
  );
}

export default EmbeddedBlock;
